// eslint-disable-next-line no-restricted-imports -- pre-existing Immutable.js action-creator; migrate to plain JS when touched
import { Map, fromJS } from 'immutable';

// eslint-disable-next-line no-restricted-imports -- pre-existing action-creator apiClient usage; migrate to api/<domain>.js when touched
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

export function fetchRadio(radio) {
  return dispatch =>
    apiClient
      .get(`/odl-app/radios/${radio}/`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.data))
      .catch(error => dispatch(genericErrorAction(error, 'FETCH_RADIO')));
}

export function radioSpecificSearch(iccid) {
  return dispatch =>
    apiClient
      .get(`/radios/search/?iccid=${iccid}`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .then(results => (results.isEmpty() ? Map() : results.first()))
      .catch(error => dispatch(genericErrorAction(error, 'REQUEST_SPECIFIC_RADIO_SEARCH')));
}

export function fetchRadioTimeline(radioId, params = {}) {
  const queryString = new URLSearchParams(params).toString();
  const url = `/radios/${radioId}/timeline/${queryString ? `?${queryString}` : ''}`;
  return dispatch =>
    apiClient
      .get(url)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => dispatch(genericErrorAction(error, 'FETCH_RADIO_TIMELINE')));
}
